import React, { ElementType, ReactElement } from 'react';
import { Menu, MenuButton, MenuItems } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import { ItemMenuListItemProps } from './types';

interface ItemMenuProps {
  children:
    | ReactElement<ItemMenuListItemProps>
    | ReactElement<ItemMenuListItemProps>[]
    | undefined;
  Icon?: ElementType;
  label?: string;
  width?: string;
}
const ItemMenu: React.FC<ItemMenuProps> = ({
  children,
  Icon = EllipsisVerticalIcon,
  label = 'Actions',
  width = 'w-32',
}) => {
  return (
    <Menu as="div" className="relative flex-none">
      <MenuButton className="-m-2.5 block p-2.5 text-gray-500 hover:text-accent">
        <span className="sr-only">{label}</span>
        <Icon aria-hidden="true" className="size-5" />
      </MenuButton>
      <MenuItems
        transition
        className={`absolute right-0 z-10 mt-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in p-2 ${width}`}
      >
        {children}
      </MenuItems>
    </Menu>
  );
};

export default ItemMenu;
